import logoDark from 'assets/logo-dark.svg';
import logoLight from 'assets/logo-light.svg';

/** Intrinsic aspect ratio (width / height) of the logo artwork. */
const ASPECT = 1001 / 176.77;

/**
 * Anablr brand logo.
 * variant: 'dark'  -> full-colour mark for light backgrounds
 *          'light' -> white mark (coral accents kept) for dark backgrounds
 * size: rendered height of the wordmark in px (glyph cap height ≈ size).
 *
 * Both width and height are set explicitly so the image can never be
 * stretched by a flex/grid parent (align-items: stretch would otherwise
 * blow the width out to the full container).
 */
export function Logo({ variant = 'dark', size = 32, className = '' }) {
  const src = variant === 'light' ? logoLight : logoDark;
  const height = Math.round(size * 1.15);
  const width = Math.round(height * ASPECT);
  return (
    <img
      src={src}
      alt="Anablr"
      width={width}
      height={height}
      className={`block max-w-full shrink-0 self-start object-contain select-none ${className}`}
      style={{ height, width }}
      draggable={false}
    />
  );
}

export default Logo;
